import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
/**
 * * 권한 없음 경고 페이지
 */

const NoPermissionPage = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate('/login');
  };
  return (
    <Result
      status='warning'
      title='권한이 없습니다. 관리자에게 문의하세요.'
      extra={<Button onClick={handleLogin}> 로그인 화면으로 돌아가기</Button>}
    />
  );
};

export default NoPermissionPage;
